 

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";

export const fetchMyNeeds = createAsyncThunk(
  "needs/ListAllNeeds",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.put(`need/ListAllNeeds`, payload);
      if (response.data.statusCode === 200) {
        return response.data.Data;
      } else {
        return rejectWithValue(response.data.msg);
      }
    } catch (error) {
      return rejectWithValue("Error fetching my needs ads");
    }
  }
);

export const fetchAllPosts = createAsyncThunk(
  "services/getAllPosts",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`services/getAllPosts`, {
        params,
      });
      if (response.data.statusCode === 200) {
        const result = {
          Data: response.data.Data,
          TotalRecords: response.data.TotalRecords,
        };
        return result;
      } else {
        return rejectWithValue(response.data.msg);
      }
    } catch (error) {
      console.error("fetchAllPosts error:", error);
      return rejectWithValue("Error fetching all posts");
    }
  }
);

const initialState = {
  allNeeds: [],
  allNeedsRequests: [],
  loading: false,
  originalLca: [], 
  status: "idle",
  error: null,
  totalRecords: "0",
};

const myNeedsSlice = createSlice({
  name: "myNeeds",
  initialState,
  reducers: {
    setAllNeeds: (state, action) => {
      state.allNeedsRequests = action.payload;
    },
    resetNeeds: (state) => {
      state.allNeeds = [];
    },
    setOriginalLca: (state, action) => {
      const uniqueAds = [
        ...new Map(action.payload.map((item) => [item.Id, item])).values(),
      ];
      const existingIds = state.originalLca.map((item) => item.Id);
      state.originalLca = [
        ...state.originalLca,
        ...uniqueAds.filter((ad) => !existingIds.includes(ad.Id)),
      ];
    },
    resetNeeds: (state) => {
      state.allNeeds = [];
      state.originalLca = [];
      state.allNeedsRequests = [];
      state.status = "idle";
      state.loading = false;
      state.error = null;
      state.totalRecords = "0";
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    removeNeed: (state, action) => {
      const needId = action.payload;
      state.allNeeds = state.allNeeds.filter((need) => need.Id !== needId);
      state.originalLca = state.originalLca.filter(
        (need) => need.Id !== needId
      );
      state.allNeedsRequests = state.allNeedsRequests.filter(
        (need) => need.Id !== needId
      );
    },
    updateNeed: (state, action) => {
      const updatedNeed = action.payload;
      state.allNeeds = (state.allNeeds || []).map((need) =>
        need.Id === updatedNeed.Id ? { ...need, ...updatedNeed } : need
      );
      state.originalLca = (state.originalLca || []).map((need) =>
        need.Id === updatedNeed.Id ? { ...need, ...updatedNeed } : need
      );
      state.allNeedsRequests = (state.allNeedsRequests || []).map((need) =>
        need.Id === updatedNeed.Id ? { ...need, ...updatedNeed } : need
      );
    },

    clearSearchResults: (state) => {
      state.allNeedsRequests = [];
      state.totalRecords = "0";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyNeeds.pending, (state) => {
        state.status = "loading";
        if (state.allNeeds.length === 0) {
          state.loading = true;
        }
        state.error = null;
      })
      .addCase(fetchMyNeeds.fulfilled, (state, action) => {
        state.status = "succeeded";
        const ads = action.payload;
        const uniqueAds = [
          ...new Map(ads.map((item) => [item.Id, item])).values(),
        ];
        const existingIdsAllNeeds = state.allNeeds.map((item) => item.Id);
        const existingIdsOriginalLca = state.originalLca.map((item) => item.Id);
        const newAllNeeds = uniqueAds.filter(
          (ad) => !existingIdsAllNeeds.includes(ad.Id)
        );
        const newOriginalLca = uniqueAds.filter(
          (ad) => !existingIdsOriginalLca.includes(ad.Id)
        );
        state.allNeeds = [...state.allNeeds, ...newAllNeeds];
        state.originalLca = [...state.originalLca, ...newOriginalLca];
        state.loading = state.allNeeds.length === 0;
        state.error = null;
      })
      .addCase(fetchMyNeeds.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
        console.error("fetchMyNeeds error:", action.payload);
      })
      .addCase(fetchAllPosts.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        // Only show loading for initial loads, not for cached requests
        state.error = null;
      })
      .addCase(fetchAllPosts.fulfilled, (state, action) => {
        state.status = "succeeded";
        const { Data, TotalRecords } = action.payload;
        const uniquePosts = [
          ...new Map(Data.map((item) => [item.Id, item])).values(),
        ];
        state.allNeedsRequests = uniquePosts;
        state.totalRecords = TotalRecords;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchAllPosts.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
        console.error("fetchAllPosts error:", action.payload);
      });
  },
});

export const {
  setAllNeeds,
  setOriginalLca,
  resetNeeds,
  setLoading,
  removeNeed,
  updateNeed,
  clearSearchResults,
} = myNeedsSlice.actions;

export default myNeedsSlice.reducer;
